<template>
  <base-page-layout title="Detalhes Operador">
    <v-card class="my-2">
      <v-card-title>
        <p class="pa-2 mf-title">{{ clubeNomeOperador }}</p>
        <p class="pa-2 mf-subheading">{{ clubeIdOperador }}</p>
      </v-card-title>
      <v-card-text>
        <v-layout>
          <span class="mf-body-2">{{ clubeIdUnidadeOperador }} - {{ clubeNomeUnidadeOperador }}</span>
          <v-spacer />
          <span class="mf-body-2">Funcionário desde: {{ clubeDataInicioOperador }}</span>
        </v-layout>
      </v-card-text>
    </v-card>
    <v-container class="px-0 pt-3 mx-0" fluid grid-list-md>
      <v-layout>
        <v-flex v-for="(card, index) in cards" :key="index" xs4 md2>
          <cbm-card
            :number-text="card.value"
            :title="card.text"
            :is-currency="card.isCurrency"
            :is-percent="card.isPercent"
            unset-percentage-colors
            simple-card
          />
        </v-flex>
      </v-layout>
    </v-container>
    <faturamento-chart />
    <cupons-chart />
  </base-page-layout>
</template>

<script>
import BasePageLayout from '@/components/BasePageLayout.vue'
import CbmCard from '@/components/CbmCard.vue'
import FaturamentoChart from '@/modules/clube/performance-operacional/views/pages/FaturamentoChart.vue'
import CuponsChart from '@/modules/clube/performance-operacional/views/pages/CuponsChart.vue'
import { mapWaitingActions } from 'vue-wait'
import { mapGetters, mapState } from 'vuex'
import { localeString } from '@/config/helpers.js'

export default {
  components: {
    BasePageLayout,
    CbmCard,
    FaturamentoChart,
    CuponsChart,
  },
  computed: {
    ...mapState({ stateOperador: (state) => state.detalhesOperador }),
    ...mapGetters([
      'clubeTotalVendasOperador',
      'clubeVendasIdentificadasOperador',
      'clubePercentualVendasIdentificadasOperador',
      'clubeTotalFaturamentoOperador',
      'clubeFaturamentoIdentificadoOperador',
      'clubePercentualFaturamentoIdentificadoOperador',
      'clubeNomeOperador',
      'clubeIdOperador',
      'clubeIdUnidadeOperador',
      'clubeNomeUnidadeOperador',
      'clubeDataInicioOperador',
    ]),
    cards() {
      return [
        {
          text: 'Total Vendas',
          value: localeString(this.clubeTotalVendasOperador || 0),
        },
        {
          text: 'Vendas Identificadas',
          value: localeString(this.clubeVendasIdentificadasOperador || 0),
        },
        {
          text: 'Percentual de Vendas Identificadas',
          value: localeString(this.clubePercentualVendasIdentificadasOperador || 0, 2),
          isPercent: true,
        },
        {
          text: 'Faturamento Total',
          value: localeString(this.clubeTotalFaturamentoOperador || 0, 0),
          isCurrency: true,
        },
        {
          text: 'Faturamento Total Identificado',
          value: localeString(this.clubeFaturamentoIdentificadoOperador || 0, 0),
          isCurrency: true,
        },
        {
          text: 'Percentual de Faturamento Identificado',
          value: localeString(this.clubePercentualFaturamentoIdentificadoOperador || 0, 2),
          isPercent: true,
        },
      ]
    },
    operador() {
      return this.stateOperador
    },
  },
  mounted() {
    this.getData()
  },
  methods: {
    ...mapWaitingActions({
      clubeDetalhesOperador: 'detalhes-operador',
    }),
    getData() {
      this.clubeDetalhesOperador({ profissional: this.$route.params.id })
    },
  },
}
</script>
